import { useEffect } from "react";
import { useMimsRegistrationState } from "@iscr/mims/context/MimsRegistrationProvider";
import { useNotifications } from "@iscr/notifications/hooks/useNotifications";
const NOTIFICATION_KEY = "mims_eula_accept";
export function useAcceptMimsEula() {
    var _a;
    const status = useMimsRegistrationState();
    const actions = (_a = status.value) === null || _a === void 0 ? void 0 : _a.actions;
    const viewEula = status.actions.viewEula;
    const { setDynamicNotification, removeDynamicNotification } = useNotifications();
    useEffect(() => {
        if (!Array.isArray(actions)) {
            return;
        }
        if (actions.includes("mims:eula:accept")) {
            setDynamicNotification(NOTIFICATION_KEY, {
                type: NOTIFICATION_KEY,
                title: "Please review the MIMS EULA",
                icon: "file alternate outline",
                action: viewEula,
                overrides: {
                    banner: true,
                    banner_variant: "info",
                },
            });
        }
        else {
            removeDynamicNotification(NOTIFICATION_KEY);
        }
    }, [actions, viewEula, setDynamicNotification, removeDynamicNotification]);
}
